import { GraviButton, MaterialIcon } from '@gravitate-js/excalibrr'
import { useQueryClient } from '@tanstack/react-query'
import type { InvoiceGroup } from '../../../../../../api/useFreight/types'
import { useInvoices } from '../../../../../../api/useFreight/useInvoices'

export function ManageHoldButton({ invoiceGroup }: { invoiceGroup: InvoiceGroup }) {
  const { useManageHoldMutation } = useInvoices()
  const queryClient = useQueryClient()

  const manageHoldMutation = useManageHoldMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['invoice'] })
      queryClient.invalidateQueries({ queryKey: ['invoices-be-query'] })
    },
  })

  const isOnHold = invoiceGroup.status === 'hold'

  const handleManageHold = () => {
    manageHoldMutation.mutate({
      invoice_group_id: invoiceGroup.id,
      on_hold: !isOnHold,
    })
  }

  return (
    <GraviButton
      style={{ fontWeight: 'bold', width: '100%' }}
      buttonText={isOnHold ? 'Remove Hold' : 'Mark On Hold'}
      icon={<MaterialIcon icon={isOnHold ? 'play_circle' : 'pause_circle'} className='pt-1' />}
      onClick={handleManageHold}
      loading={manageHoldMutation.isPending}
    />
  )
}
